/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_TransitionInputs */

const cs_viewings_transition = /** @type {(inputs: Viewings_TransitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit stav`)
};

const en_viewings_transition = /** @type {(inputs: Viewings_TransitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update status`)
};

/**
* | output |
* | --- |
* | "Update status" |
*
* @param {Viewings_TransitionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_transition = /** @type {((inputs?: Viewings_TransitionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_TransitionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_transition(inputs)
	return cs_viewings_transition(inputs)
});